import styled from '@emotion/styled'

import { palette, spacing, Text } from 'main/ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const Label = styled(Text)`
  color: ${palette.mediumGray};
  margin-bottom: ${spacing.minorScale(1)}px;
`
